module.exports = __webpack_public_path__ + "static/media/sonicscale-2.dc573122.jpg";